<template>
    <template v-if="normalizedErrors.length">
        <div v-for="(error, index) in normalizedErrors" :key="index" class="cm-form-error-message">
            {{ error }}
        </div>
    </template>
</template>

<script setup>
import { computed } from 'vue'

import { useNormalizer } from "@jinkosoft/utils";

const { normalizeInput } = useNormalizer()

const props = defineProps({
    errors: {
        type    : [Array, Object],
        default : () => []
    }
})

const normalizedErrors = computed(() => normalizeInput(props.errors))
</script>